<template>
  <section v-if="banners && banners.length">
    <div v-if="type == 'main'" class="gc-banner">
      <div
        v-for="(slide, i) in banners"
        v-show="i === index"
        :key="i"
        class="gc-banner-slide"
        @click="redirectTo(slide)"
      >
        <img
          v-if="slide.type == 'image'"
          :src="getAssetURL(slide.file)"
          :alt="plainText(slide.title) || 'Promotion'"
        />
        <div
          v-if="slide.showContent"
          class="gc-banner-copy"
          :style="{ textAlign: slide.contentAlignment || 'left' }"
        >
          <h1 class="mb-3" v-html="slide.title"></h1>
          <p class="mb-4" v-html="slide.description"></p>
          <div>
            <v-btn rounded large class="nott" color="primary">
              {{ slide.buttonText || "Shop now" }}
            </v-btn>
          </div>
        </div>
      </div>
      <div v-if="banners.length > 1" class="gc-banner-dots">
        <button
          v-for="(slide, i) in banners"
          :key="'dot-' + i"
          type="button"
          :class="{ on: i === index }"
          :aria-label="'Slide ' + (i + 1)"
          @click.stop="index = i"
        ></button>
      </div>
    </div>

    <v-row v-if="type == 'mini'">
      <v-col
        v-for="(slide, i) in banners"
        :key="i"
        sm="6"
        cols="12"
        @click="redirectTo(slide)"
      >
        <div v-if="slide.type == 'image'" class="gc-mini-banner">
          <img :src="getAssetURL(slide.file)" :alt="plainText(slide.title) || 'Offer'" />
          <div v-if="slide.showContent" class="gc-banner-copy">
            <h2 v-html="slide.title"></h2>
            <span v-html="slide.description"></span>
          </div>
        </div>
      </v-col>
    </v-row>
    <div v-if="ismb" class="mb-8"></div>
  </section>
</template>
<script>
import Store from "../../services/store";

export default {
  name: "MainBanners",

  props: ["ismb", "type", "banners", "fullscreen"],

  data() {
    return {
      index: 0,
    };
  },

  methods: {
    getAssetURL(data) {
      return Store.getAssetURL(data);
    },

    plainText(value) {
      return value ? String(value).replace(/<[^>]+>/g, "") : "";
    },

    redirectTo(item) {
      if (!item) return;
      if (item.redirectTo === "category" && item.redirectToCategory) {
        if (item.redirectToCategory.isActive && !item.redirectToCategory.deleted) {
          this.$router.push({
            name: "category",
            params: {
              slug: item.redirectToCategory.slug || item.redirectToCategory._id,
            },
          });
        }
      } else if (item.redirectTo === "product" && item.redirectToProduct) {
        if (item.redirectToProduct.isActive && !item.redirectToProduct.deleted) {
          this.$router.push({
            name: "product",
            params: {
              slug: item.redirectToProduct.slug || item.redirectToProduct._id,
            },
          });
        }
      } else if (item.redirectTo === "group" && item.redirectToGroup) {
        if (item.redirectToGroup.isActive && !item.redirectToGroup.deleted) {
          this.$router.push({
            name: "collection",
            params: {
              slug: item.redirectToGroup.slug || item.redirectToGroup._id,
            },
          });
        }
      } else if (item.redirectTo === "url" && item.redirectToURL) {
        window.open(item.redirectToURL, "_system");
      }
    },
  },
};
</script>
